import router from '@/router';
import { removeRouterVisit, setRouterVisit } from '@/utils/routerVisit';
import { ref } from 'vue';

const tabs = ref([]);
const activeTab = ref('Home');
const initTab = () => {
    let visitRouterSessionStorage = sessionStorage.getItem('visitRouterSessionStorage')
    if(visitRouterSessionStorage && visitRouterSessionStorage !== "[]"){
        tabs.value = JSON.parse(visitRouterSessionStorage).filter(item=>item.path!='/login')
    }
}
const openTab = (route) => {
    if (!tabs.value.some(tab => tab.name === route.name)) {
        tabs.value.push({
            name: route.name,
            path: route.path,
            meta: route.meta
        });
    }
    activeTab.value = route.path;
    setRouterVisit(route,'add');
};

const closeTab = (tabPath) => {
    console.log(tabPath)
    const index = tabs.value.findIndex(tab => tab.path === tabPath);
    if (index > -1) {
        tabs.value.splice(index, 1);
        // removeRouterVisit(tabs.value[index])
        if (activeTab.value === tabPath) {
            if (tabs.value.length > 0) {
                activeTab.value = tabs.value[tabs.value.length - 1].path;
                router.push(tabs.value[tabs.value.length - 1].path)
            } else {
                activeTab.value = '';
            }
        }
    }
};

const setActiveTab = (tabPath) => {
    activeTab.value = tabPath;
};

export {
    initTab,
    tabs,
    activeTab,
    openTab,
    closeTab,
    setActiveTab
};